<div class="flex flex-col gap-1">

  <label class="kt-form-label font-medium text-xs mb-1">

    {{ field.label }}

  </label>

  <input
    type="date"
    class="kt-input kt-input-sm"
    [formControl]="control" />

  <mat-error *ngIf="isInvalid">

    {{ getError() }}

  </mat-error>

</div>